import * as z from "zod";
import { LanguageValidationSchema } from "@/components/pages/Settings/validation/languageValidationSchema";
import { AddressValidationSchema } from "@/components/pages/Settings/validation/addressValidationSchema";
import { CountryValidationSchema } from "@/components/pages/Settings/validation/countryValidationSchema";
import { BankAccountValidationSchema } from "@/components/pages/Settings/validation/bankAccountValidationSchema";
import { CreditValidationSchema } from "@/components/pages/Settings/validation/creditValidationSchema";
import { TimeZoneValidationSchema } from "@/components/pages/Settings/validation/timeZoneValidationSchema";
import { CompanyPrivateNetworkValidationSchema } from "@/components/pages/Settings/validation/companyPrivateNetworkValidationSchema";

const validationSchema = z.object({
  id: z.number().int().nonnegative(),
  email: z
    .string({ message: "validation:emailRequired" })
    .min(1, { message: "validation:emailRequired" })
    .email({ message: "validation:invalidEmail" }),
  invoiceemail: z.string().email().optional(),
  companyName: z.string().min(1, { message: "validation:companyNameRequired" }),
  vatNumber: z.string().min(1, { message: "validation:vatNumberRequired" }),
  leiNumber: z.string(),
  eoriNumber: z.string(),
  phone: z.string().min(1, { message: "validation:phoneNumberRequired" }),
  companyAddress: z.array(AddressValidationSchema).min(1, { message: "validation:addressRequired" }),
  companyCountryCode: CountryValidationSchema,
  companyAttest: z.string().optional(),
  bankAccount: z.array(BankAccountValidationSchema).optional(),
  defaultCurrency: z
    .string({ message: "validation:currencyRequired" })
    .min(1, { message: "validation:currencyRequired" }),
  language: LanguageValidationSchema,
  withoutTransport: z.boolean(),
  companyType: z.enum(["ADMIN", "TRADER", "TRANSPORT", "DEPARTMENT"]),
  timeZone: z.string({ message: "validation:timeZoneRequired" }).min(1, { message: "validation:timeZoneRequired" }),
  membership: z.string().min(1),
  preferredTransportCompanyId: z.number().optional().nullable(),
  alwaysInvoice: z.boolean(),
  feeDiscountPercentage: z.number().nonnegative().max(100),
  newCompany: z.boolean(),
  credit: CreditValidationSchema,
  transportCutoffTime: TimeZoneValidationSchema.optional(),
  exportLicense: z.string().optional(),
  allowCollectiveInvoice: z.boolean(),
  companyPrivateNetwork: z.array(CompanyPrivateNetworkValidationSchema).optional(),
  notificationEmail: z.string().email().optional(),
  glnNo: z.string().optional(),
  customsAccountNo: z.string().optional(),
  integrationWithExternalERP: z.boolean(),
  eternalErpId: z.number().optional(),
  transportCompanyPropertiesId: z.number().optional(),
  isOrderPlanningEnabled: z.boolean(),
});

export const CompanyValidationSchema = validationSchema;
export type CompanyFormInput = z.infer<typeof CompanyValidationSchema>;
